import Stage2Player3Room from "../shared/Stage2Player3Room";

export default function Four_Players_Stage2_Player3(props) {
  return <Stage2Player3Room {...props} playerCount={4} hasStressMonitor={false} />;
}